import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-6481').catch(console.error);
